import { createSelector } from 'reselect';
import { enabledButtonsSelector } from './enabled-buttons-selector.esm.js';

var getShowSelectedFooter = function getShowSelectedFooter(buttonsEnabled) {
  return buttonsEnabled["delete"] || buttonsEnabled.saveAs || buttonsEnabled.save;
};
var showSelectedFooterSelector = createSelector(enabledButtonsSelector, getShowSelectedFooter);

export { getShowSelectedFooter, showSelectedFooterSelector };
//# sourceMappingURL=show-selected-footer-selector.esm.js.map
